import Logger from 'redux-logger'

const middleware = []
if (process.env.NODE_ENV === 'development') {
  middleware.push(Logger)
}

export default middleware
